import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {DisposableObject} from "../../../../utils/disposable-object";

export abstract class ExternalLinkHandlerBase extends DisposableObject {
    constructor(protected readonly services: IServiceFactoryExtended) {
        super()
    }


    protected _openInNewTab(url: string): void {
        if(this.services.device.hybrid.isHybrid) {
            this.services.hybrid.openExternalLink(url);
        } else {
            this.services.window.openInNewTab(url);
        }
    }
}